import { Commit } from '@/store/types'
import { AlertApi } from '@/store/modules/alerts/types'
import { getEnvironments } from '@/environments'
import { eraseCookie, getCookie, setCookie } from './CookieService'
export interface UserCredentials {
  password: string;
  email: string;
}

export interface AlertInterface {
  getAlerts(): Promise<Commit<AlertApi>>
}

export class AlertService implements AlertInterface {
  env = getEnvironments()
  cookieName = '__alerta_jwt__'
  tokenName = 'access_token'
  cookieTime = 30
  apiUrl: string = this.env.url.API ? this.env.url.API : window.location.origin
  constructor (apiUrl?: string) {
    this.apiUrl = apiUrl || this.apiUrl
  }

  async getAlerts (): Promise<Commit<any>> {
    const response = await fetch(`${this.apiUrl}/api/alerta`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    const responseJson = await response.json()
    return {
      type: 'ALERTS_UPDATED',
      payload: responseJson
    }
  }
}
